import config from "react-global-configuration";
import { configService } from "./../configService";
import axios from "axios";
import { authHeader } from "../../helpers";
import  apiInterceptor  from "../auth/apiInterceptor";
import api from "../auth/apiInterceptor";

export const betSlipService = {
  GameLaunchUrlToken,
  betsList,
  placeBet,
  LeaderboardList,
  filterdate,
  fatchUserDetails,
  fatchUserTotalBalance,
  fatchGamesAll,
  fatchgetPaymentMethods,
  getFieldsPaymentMethods,
  updateUserDetails,
  filterdatewallet,
  walletList,
  resetPassword,
  changePassword,
  sendotp,
  updateUserProfile,
  LimitDetails,
  updateLimit,
  updateLimitAdmin,
  resumeRequest,
  gameCategory,
  games,
  gamesLog,
  APIGetAccount,
  APIGetBalance,
  APITransectionStatus,
  APIGetTransection,
  APIWalletDebit,
  APIWalletCredit,
  APITransectionTypeResult,
  APITransectionTypeRollback,
  APIManualBonusTypeTransaction,
  APIBonusCompletedTypeTransaction,
  SaveCotactUs,
  APIGetClientDetails,
  APIGetClientBalance,
  APIBetPlaced,
  APIBetResulted,
  gameVendor,
  gameProvider,
  APITransectionTypeIsReversal,
  s_g_2,
  s_g_3,
  home_game_list,
  games_home_categories,
  casino_page_categories,
  GameLaunchUrl,
  s_g_4,
  s_g_6,
  s_g_12,
  APIKycAuth,
  Kyc_token,
  cmsPagesList,
  cmsPageDetails,
  addAmountToWallet,
  userWalletList,
  userGameplay,
  updateTransactionData,
  userdocumnet,
  userkyclist,
  userkyclistimage,
  userWithdrawList,
  nonCashWallet,
  userWithdrawRequest,
  useBridgerPayPayout,
  useApcoPayPayout,
  relaxgaming,
  gameLiveCategory,
  livegames,
  gamePokerCategory,
  pokergames,
  Banner,
  SiteLogo,
  gameCategoryLists,
  Promotion,
  getFeaturedGameList,
  manageuserServices,
  casinoCategoryList,
  casinoCategoryLiveList,
  casinoPageGames,
  makePayment
};

function manageuserServices(reqData) {
  let params = typeof reqData == "undefined" ? {} : reqData;

    return apiInterceptor
      .get(`${config.get("apiUrl")}/manage-user-services`, {})
    .then(configService.handleResponse)
    .then((response) => {
      return response;
    })
    .catch((err) => configService.handleApiError(err));
}

function getFeaturedGameList(reqData) {
  return apiInterceptor
    .get(`${config.get("apiUrl")}/featured-game-list`)
    .then(configService.handleResponse)
    .then((response) => {
      return response;
      console.log("cData", response);
    })
    .catch((err) => configService.handleApiError(err));
}

function gameCategoryLists(reqData) {
  return apiInterceptor
    .get(`${config.get("apiUrl")}/game-category`)
    .then(configService.handleResponse)
    .then((response) => {
      return response;
      console.log("cData", response);
    })
    .catch((err) => configService.handleApiError(err));
}

function casinoCategoryList(reqData) {
  return apiInterceptor
    .get(`${config.get("apiUrl")}/casino-categories-list`)
    .then(configService.handleResponse)
    .then((response) => {
      return response;
      console.log("cData", response);
    })
    .catch((err) => configService.handleApiError(err));
}


function casinoCategoryLiveList(reqData) {
  return apiInterceptor
    .get(`${config.get("apiUrl")}/casino-categories-list-live`)
    .then(configService.handleResponse)
    .then((response) => {
      return response;
      console.log("cData", response);
    })
    .catch((err) => configService.handleApiError(err));
}



function nonCashWallet(reqData) {
  let params = typeof reqData == "undefined" ? {} : reqData;
  return apiInterceptor
    .get(`${config.get("apiUrl")}/user-wallet/noncash-list`, {
      params: params,
    })
    .then(configService.handleResponse)
    .then((response) => {
      return response.data;
    })
    .catch((err) => configService.handleApiError(err));
}

function userWithdrawList(reqData) {
  let params = typeof reqData == "undefined" ? {} : reqData;
  return apiInterceptor
    .get(`${config.get("apiUrl")}/user-withdraw-list`, { })
    .then(configService.handleResponse)
    .then((response) => {
      return response.data;
    })
    .catch((err) => configService.handleApiError(err));
}

function userWithdrawRequest(data) {
  return apiInterceptor
    .post(`${config.get("apiUrl")}/add-withdrawal-request`, data)
    .then(configService.handleResponse)
    .then((response) => {
      return response;
    })
    .catch((err) => configService.handleApiError(err));
}


function useBridgerPayPayout(data) {
  return apiInterceptor
    .post(`${config.get("apiUrl")}/bridgerPayPayout`, data)
    .then(configService.handleResponse)
    .then((response) => {
      return response;
    })
    .catch((err) => configService.handleApiError(err));
}
function useApcoPayPayout(data) {
  return apiInterceptor
    .post(`${config.get("apiUrl")}/apcoPayPayout`, data)
    .then(configService.handleResponse)
    .then((response) => {
      return response;
    })
    .catch((err) => configService.handleApiError(err));
}



function userWalletList(reqData) {
  let params = typeof reqData == "undefined" ? {} : reqData;
  return apiInterceptor
    .get(`${config.get("apiUrl")}/user-wallet/list`, {
      params: params,
    })
    .then(configService.handleResponse)
    .then((response) => {
      return response.data;
    })
    .catch((err) => configService.handleApiError(err));
}

function makePayment(reqData = {}) {
  return apiInterceptor
    .get(`${config.get("apiUrl")}/makePayment`, { params: reqData })
    .then((response) => {
      console.log("makePayment response:", response.data);
      // Assuming you want to return the actual response data
      return response.data;
    })
    .catch((err) => configService.handleApiError(err));
}

function userGameplay(reqData) {
  let params = typeof reqData == "undefined" ? {} : reqData;
  return apiInterceptor
    .get(`${config.get("apiUrl")}/user-wallet/gameplay-list`, {})
    .then(configService.handleResponse)
    .then((response) => {
      return response.data;
    })
    .catch((err) => configService.handleApiError(err));
}

function addAmountToWallet(data) {
  return apiInterceptor
    .post(`${config.get("apiUrl")}/user-wallet/add-amount`, data)
    .then(configService.handleResponse)
    .then((response) => {
      return response;
    })
    .catch((err) => configService.handleApiError(err));
}

function updateTransactionData(data) {
  return apiInterceptor
    .post(`${config.get("apiUrl")}/user-wallet/update-transation`, data)
    .then(configService.handleResponse)
    .then((response) => {
      return response;
    })
    .catch((err) => configService.handleApiError(err));
}

function cmsPagesList() {
  return apiInterceptor
    .get(`${config.get("apiUrl")}/get-cms-list`)
    .then(configService.handleResponse)
    .then((response) => {
      return response;
      console.log("cData", response);
    })
    .catch((err) => configService.handleApiError(err));
}

function cmsPageDetails(data) {
  return apiInterceptor
    .post(`${config.get("apiUrl")}/cms_pages/detail`, data)
    .then(configService.handleResponse)
    .then((response) => {
      return response;
    })
    .catch((err) => configService.handleApiError(err));
}

function Kyc_token(data) {
  //return
  // axios
  //     .post(`${config.get('apiUrl')}/BetPlaced`, data)
  //     .then(configService.handleResponse)
  //     .then(response => {
  //         return response;
  //     })
  //     .catch(err => configService.handleApiError(err));

  apiInterceptor
    .post("https://demo-api.gii.cloud/api/oauth/token", {
      data,
    })
    .then(function (response) {
      console.log("token verification api ", response);
    })
    .catch(function (error) {
      console.log(error);
    });
}

function APIKycAuth(data) {
  return apiInterceptor
    .post(`${config.get("apiUrl")}/kycauth`, data)
    .then(configService.handleResponse)
    .then((response) => {
      return response;
    })
    .catch((err) => configService.handleApiError(err));
}
function s_g_2(data) {
  return apiInterceptor
    .get(`${config.get("apiUrl")}/s_g_2`, data)
    .then(configService.handleResponse)
    .then((response) => {
      return response;
    })
    .catch((err) => configService.handleApiError(err));
}
function s_g_3(data) {
  return apiInterceptor
    .get(`${config.get("apiUrl")}/s_g_3`, data)
    .then(configService.handleResponse)
    .then((response) => {
      return response;
    })
    .catch((err) => configService.handleApiError(err));
}

function home_game_list(data) {
  return apiInterceptor
    .get(`${config.get("apiUrl")}/home-game-list`, data)
    .then(configService.handleResponse)
    .then((response) => {
      return response;
    })
    .catch((err) => configService.handleApiError(err));
}

function s_g_4(data) {
  return apiInterceptor
    .get(`${config.get("apiUrl")}/s_g_4`, data)
    .then(configService.handleResponse)
    .then((response) => {
      return response;
    })
    .catch((err) => configService.handleApiError(err));
}

function GameLaunchUrl(data) {
  return apiInterceptor
    .post(`${config.get("apiUrl")}/game_launch_url`,data)
    .then(configService.handleResponse)
    .then((response) => {
      return response;
    })
    .catch((err) => configService.handleApiError(err));
}
function GameLaunchUrlToken(data) {
  return apiInterceptor
    .post(`${config.get("apiUrl")}/game_launch_token`,data)
    .then(configService.handleResponse)
    .then((response) => {
      return response;
    })
    .catch((err) => configService.handleApiError(err));
}

function s_g_6(data) {
  return apiInterceptor
    .get(`${config.get("apiUrl")}/s_g_6`, data)
    .then(configService.handleResponse)
    .then((response) => {
      return response;
    })
    .catch((err) => configService.handleApiError(err));
}

function s_g_12(data) {
  return apiInterceptor
    .get(`${config.get("apiUrl")}/s_g_12`, data)
    .then(configService.handleResponse)
    .then((response) => {
      return response;
    })
    .catch((err) => configService.handleApiError(err));
}

function gameVendor(data) {
  // return apiInterceptor
  //   .get(`${config.get("apiUrl")}/wallet/gameVendor`, data)

    return apiInterceptor
      .get(`${config.get("apiUrl")}/wallet/gameVendor`, data,{})
    .then(configService.handleResponse)
    .then((response) => {
      return response;
    })
    .catch((err) => configService.handleApiError(err));
}

function gameProvider(data) {
  return apiInterceptor
    .get(`${config.get("apiUrl")}/game-provider`, data)
    .then(configService.handleResponse)
    .then((response) => {
      return response;
    })
    .catch((err) => configService.handleApiError(err));
}

function APIBetResulted(data) {
  return apiInterceptor
    .post(`${config.get("apiUrl")}/BetResulted`, data)
    .then(configService.handleResponse)
    .then((response) => {
      return response;
    })
    .catch((err) => configService.handleApiError(err));
}
function APIBetPlaced(data) {
  return apiInterceptor
    .post(`${config.get("apiUrl")}/BetPlaced`, data)
    .then(configService.handleResponse)
    .then((response) => {
      return response;
    })
    .catch((err) => configService.handleApiError(err));
}
function APIGetClientDetails(data) {
  return apiInterceptor
    .post(`${config.get("apiUrl")}/wallet/Authentication`, data)
    .then(configService.handleResponse)
    .then((response) => {
      return response;
    })
    .catch((err) => configService.handleApiError(err));
}
function APIGetClientBalance(data) {
  return apiInterceptor
    .post(`${config.get("apiUrl")}/GetBalance`, data, {headers: authHeader()})
    .then(configService.handleResponse)
    .then((response) => {
      return response;
    })
    .catch((err) => configService.handleApiError(err));
}
function APIBonusCompletedTypeTransaction(data) {
  return apiInterceptor
    .post(`${config.get("apiUrl")}/wallet`, data)
    .then(configService.handleResponse)
    .then((response) => {
      return response;
    })
    .catch((err) => configService.handleApiError(err));
}
function APITransectionTypeIsReversal(data) {
  return apiInterceptor
    .post(`${config.get("apiUrl")}/wallet`, data)
    .then(configService.handleResponse)
    .then((response) => {
      return response;
    })
    .catch((err) => configService.handleApiError(err));
}
function APIManualBonusTypeTransaction(data) {
  return apiInterceptor
    .post(`${config.get("apiUrl")}/wallet`, data)
    .then(configService.handleResponse)
    .then((response) => {
      return response;
    })
    .catch((err) => configService.handleApiError(err));
}
function APITransectionTypeRollback(data) {
  return apiInterceptor
    .post(`${config.get("apiUrl")}/wallet`, data)
    .then(configService.handleResponse)
    .then((response) => {
      return response;
    })
    .catch((err) => configService.handleApiError(err));
}
function APITransectionTypeResult(data) {
  return apiInterceptor
    .post(`${config.get("apiUrl")}/wallet`, data)
    .then(configService.handleResponse)
    .then((response) => {
      return response;
    })
    .catch((err) => configService.handleApiError(err));
}
function APIWalletCredit(data) {
  return apiInterceptor
    .post(`${config.get("apiUrl")}/wallet`, data)
    .then(configService.handleResponse)
    .then((response) => {
      return response;
    })
    .catch((err) => configService.handleApiError(err));
}
function APIWalletDebit(data) {
  return apiInterceptor
    .post(`${config.get("apiUrl")}/wallet`, data)
    .then(configService.handleResponse)
    .then((response) => {
      return response;
    })
    .catch((err) => configService.handleApiError(err));
}

function APIGetTransection(data) {
  return apiInterceptor
    .post(`${config.get("apiUrl")}/wallet`, data)
    .then(configService.handleResponse)
    .then((response) => {
      return response;
    })
    .catch((err) => configService.handleApiError(err));
}

function APITransectionStatus(data) {
  return apiInterceptor
    .post(`${config.get("apiUrl")}/wallet`, data)
    .then(configService.handleResponse)
    .then((response) => {
      return response;
    })
    .catch((err) => configService.handleApiError(err));
}

function APIGetBalance(data) {
  return apiInterceptor
    .post(`${config.get("apiUrl")}/wallet`, data)
    .then(configService.handleResponse)
    .then((response) => {
      return response;
    })
    .catch((err) => configService.handleApiError(err));
}

function APIGetAccount(data) {
  return apiInterceptor
    .post(`${config.get("apiUrl")}/wallet`, data)
    .then(configService.handleResponse)
    .then((response) => {
      return response;
    })
    .catch((err) => configService.handleApiError(err));
}

function gamesLog(data) {
  return apiInterceptor
    .post(`${config.get("apiUrl")}/wallet/gameLog`, data)
    .then(configService.handleResponse)
    .then((response) => {
      return response;
    })
    .catch((err) => configService.handleApiError(err));
}

function games(data) {
  return apiInterceptor
    .post(`${config.get("apiUrl")}/filter-games`, data)
    .then(configService.handleResponse)
    .then((response) => {
      return response;
    })
    .catch((err) => configService.handleApiError(err));
}

function casinoPageGames(data) {
  return apiInterceptor
    .get(`${config.get("apiUrl")}/games-casino-categories`, { params: data })
    .then(configService.handleResponse)
    .then((response) => {
      return response;
    })
    .catch((err) => configService.handleApiError(err));
}

function livegames(data) {
  return apiInterceptor
    .post(`${config.get("apiUrl")}/wallet/LiveFilterGames`, data)
    .then(configService.handleResponse)
    .then((response) => {
      return response;
    })
    .catch((err) => configService.handleApiError(err));
}
function pokergames(data) {
  return apiInterceptor
    .post(`${config.get("apiUrl")}/wallet/PokerGames`, data)
    .then(configService.handleResponse)
    .then((response) => {
      return response;
    })
    .catch((err) => configService.handleApiError(err));
}

function gameCategory() {
  return apiInterceptor
    .get(`${config.get("apiUrl")}/wallet/GameCatgeories`)
    .then(configService.handleResponse)
    .then((response) => {
      return response;
    })
    .catch((err) => configService.handleApiError(err));
}
function gameLiveCategory() {
  return apiInterceptor
    .get(`${config.get("apiUrl")}/wallet/GameLiveCatgeories`)
    .then(configService.handleResponse)
    .then((response) => {
      return response;
    })
    .catch((err) => configService.handleApiError(err));
}
function gamePokerCategory() {
  return apiInterceptor
    .get(`${config.get("apiUrl")}/wallet/GamePokerCatgeories`)
    .then(configService.handleResponse)
    .then((response) => {
      return response;
    })
    .catch((err) => configService.handleApiError(err));
}

function resumeRequest(data) {
  return apiInterceptor
    .post(`${config.get("apiUrl")}/resumeRequest`, data)
    .then(configService.handleResponse)
    .then((response) => {
      return response;
    })
    .catch((err) => configService.handleApiError(err));
}

function updateLimit(data) {
  return apiInterceptor
    .post(`${config.get("apiUrl")}/updateLimit`, data)
    .then(configService.handleResponse)
    .then((response) => {
      return response;
    })
    .catch((err) => configService.handleApiError(err));
}

function updateLimitAdmin(data) {
  return apiInterceptor
    .post(`${config.get("apiUrl")}/updateLimitAdmin`, data)
    .then(configService.handleResponse)
    .then((response) => {
      return response;
    })
    .catch((err) => configService.handleApiError(err));
}

function LimitDetails(data) {
 
  return apiInterceptor.post(
    `${config.get("apiUrl")}/LimitDetails`,  data,
  )
  .then(configService.handleResponse)
  .then((response) => {
    return response;
  })
  .catch((err) => configService.handleApiError(err));
}

// function LimitDetails(data) {
//   return apiClient.post('/LimitDetails', data)
//     .then(configService.handleResponse)
//     .then((response) => response)
//     .catch((err) => configService.handleApiError(err));
// }

function updateUserProfile(data) {
  return apiInterceptor
    .post(`${config.get("apiUrl")}/updateUserProfile`, data)
    .then(configService.handleResponse)
    .then((response) => {
      return response;
    })
    .catch((err) => configService.handleApiError(err));
}

function sendotp(data) {
  return apiInterceptor
    .post(`${config.get("apiUrl")}/sendotp`, data)
    .then(configService.handleResponse)
    .then((response) => {
      return response;
    })
    .catch((err) => configService.handleApiError(err));
}

function betsList() {
  return apiInterceptor
    .post(`${config.get("apiUrl")}/bet-slips`)
    .then(configService.handleResponse)
    .then((response) => {
      return response;
    })
    .catch((err) => configService.handleApiError(err));
}

function placeBet(betSlips) {
  return apiInterceptor
    .post(`${config.get("apiUrl")}/bet/create`, { bet_slips: betSlips })
    .then(configService.handleResponse)
    .then((response) => {
      return response;
    })
    .catch((err) => configService.handleApiError(err));
}
function LeaderboardList() {
  return apiInterceptor
    .get(`${config.get("apiUrl")}/report/leaderboard`)
    .then(configService.handleResponse)
    .then((response) => {
      return response;
    })
    .catch((err) => configService.handleApiError(err));
}
function filterdate(M) {
  //console.log('date:',M)
  return apiInterceptor
    .post(`${config.get("apiUrl")}/report/leaderboard`, { M: M })
    .then(configService.handleResponse)
    .then((response) => {
      return response;
    })
    .catch((err) => configService.handleApiError(err));
}

function filterdatewallet(date, guid) {
  console.log("date:=====", date);
  return apiInterceptor
    .post(`${config.get("apiUrl")}/report/wallet`, { date: date, guid: guid })
    .then(configService.handleResponse)
    .then((response) => {
      return response;
    })
    .catch((err) => configService.handleApiError(err));
}
function walletList() {
  return apiInterceptor
    .get(`${config.get("apiUrl")}/report/wallet`)
    .then(configService.handleResponse)
    .then((response) => {
      return response;
    })
    .catch((err) => configService.handleApiError(err));
}

function fatchUserDetails(reqData) {
  let params = typeof reqData == "undefined" ? {} : reqData;
  return apiInterceptor
  .get(`${config.get("apiUrl")}/userDetails`, {})
  .then(configService.handleResponse)
  .then((response) => {
    return response;
  })
  .catch((err) => configService.handleApiError(err));
}

function fatchUserTotalBalance(reqData) {
  let params = typeof reqData == "undefined" ? {} : reqData;
  return apiInterceptor
  .get(`${config.get("apiUrl")}/userBalance`, {params})
  .then(configService.handleResponse)
  .then((response) => {
    return response;
  })
  .catch((err) => configService.handleApiError(err));
}


function fatchGamesAll(reqData) {
  let params = typeof reqData == "undefined" ? {} : reqData;
  return apiInterceptor
    .get(`${config.get("apiUrl")}/search-games-all`, {
      params: params,
    })
    .then(configService.handleResponse)
    .then((response) => {
      return response;
    })
    .catch((err) => configService.handleApiError(err));
}

function fatchgetPaymentMethods(reqData) {
  let params = typeof reqData == "undefined" ? {} : reqData;
  return apiInterceptor
    .get(`${config.get("apiUrl")}/getPaymentMethodsOfBridgerPay`, {
      params: params,
    })
    .then(configService.handleResponse)
    .then((response) => {
      return response;
    })
    .catch((err) => configService.handleApiError(err));
}

function getFieldsPaymentMethods(reqData) {
  let params = typeof reqData == "undefined" ? {} : reqData;
  return apiInterceptor
    .get(`${config.get("apiUrl")}/fields-of-payment-method`, {
      params: params,
    })
    .then(configService.handleResponse)
    .then((response) => {
      return response;
    })
    .catch((err) => configService.handleApiError(err));
}


function updateUserDetails(data) {
  return apiInterceptor
    .post(`${config.get("apiUrl")}/updateUserDetails`, data)
    .then(configService.handleResponse)
    .then((response) => {
      return response;
    })
    .catch((err) => configService.handleApiError(err));
}
function SaveCotactUs(data) {
  console.log("data", data);
  return apiInterceptor
    .post(`${config.get("apiUrl")}/bet/contactus`, data)
    .then(configService.handleResponse)
    .then((response) => {
      return response;
    })
    .catch((err) => configService.handleApiError(err));
}

function resetPassword(data) {
  return apiInterceptor
    .post(`${config.get("apiUrl")}/resetPassword`, data)
    .then(configService.handleResponse)
    .then((response) => {
      return response;
    })
    .catch((err) => configService.handleApiError(err));
}
function changePassword(data) {
  return apiInterceptor
    .post(`${config.get("apiUrl")}/change-password`, data)
    .then(configService.handleResponse)
    .then((response) => {
      return response;
    })
    .catch((err) => configService.handleApiError(err));
}
function relaxgaming(data) {
  return apiInterceptor
    .post(`${config.get("apiUrl")}/RelaxGameList`, data)
    .then(configService.handleResponse)
    .then((response) => {
      return response;
    })
    .catch((err) => configService.handleApiError(err));
}
function userkyclist(reqData) {
  let params = typeof reqData == "undefined" ? {} : reqData;
  return apiInterceptor
    .get(`${config.get("apiUrl")}/kyc_list`, {})
    .then(configService.handleResponse)
    .then((response) => {
      return response.data;
    })
    .catch((err) => configService.handleApiError(err));
}
function userkyclistimage(reqData) {
  let params = typeof reqData == "undefined" ? {} : reqData;
  return apiInterceptor
    .get(`${config.get("apiUrl")}/document`, {
      params: params,
    })
    .then(configService.handleResponse)
    .then((response) => {
      return response;
    })
    .catch((err) => configService.handleApiError(err));
}

function userdocumnet(data) {
  return apiInterceptor
      .post(`${config.get("apiUrl")}/uploaddocument`, data, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    })
    .then(configService.handleResponse)
    .then((response) => {
      return response;
    })
    .catch((err) => configService.handleApiError(err));
}


function Banner(data) {
  return apiInterceptor
    .get(`${config.get("apiUrl")}/banner/getbanner`, data)
    .then(configService.handleResponse)
    .then((response) => {
      return response;
    })
    .catch((err) => configService.handleApiError(err));
}
function SiteLogo(data) {
  return apiInterceptor
    .get(`${config.get("apiUrl")}/site-logo`, data)
    .then(configService.handleResponse)
    .then((response) => {
      return response;
    })
    .catch((err) => configService.handleApiError(err));
}

function Promotion(data) {
  return apiInterceptor
    .get(`${config.get("apiUrl")}/promotion/getpromotion`, data)
    .then(configService.handleResponse)
    .then((response) => {
      return response;
    })
    .catch((err) => configService.handleApiError(err));
}

function games_home_categories(reqData) {
  let params = typeof reqData == "undefined" ? {} : reqData;
  return apiInterceptor
    .get(`${config.get("apiUrl")}/games-home-categories`, {
      params: params,
    })
    .then(configService.handleResponse)
    .then((response) => {
      return response;
    })
    .catch((err) => configService.handleApiError(err));
}

function casino_page_categories(reqData) {
  let params = typeof reqData == "undefined" ? {} : reqData;
  return apiInterceptor
    .get(`${config.get("apiUrl")}/casino-categories-list`, {
      params: params,
    })
    .then(configService.handleResponse)
    .then((response) => {
      return response;
    })
    .catch((err) => configService.handleApiError(err));
}